// import { useRef } from "react";
// import { Link } from "react-router-dom";
//
// import useCatalogueData from "hook/useCatalogueData";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import NoDataView from "../noDataView";
// import useHorizontalScrollButtons from "../../utils/useHorizontalScrollButtons";
//
// const Catalogue = () => {
//   const scrollRef = useRef(null);
//   const leftBtnRef = useRef(null);
//   const rightBtnRef = useRef(null);
//
//   const { catalogues, loadingCatalogue } = useCatalogueData();
//   const { scroll } = useHorizontalScrollButtons({scrollRef, leftBtnRef, rightBtnRef, dependency: [catalogues],});
//
//   if (!loadingCatalogue && !catalogues.length) {
//     return (
//         <NoDataView title="কোনো ক্যাটাগরি নেই"/>
//     );
//   }
//
//   return (
//     <div className="container mx-auto relative mb-3">
//       {/* Header */}
//       {loadingCatalogue ? (
//         <div className="flex justify-center my-3">
//           {" "}
//           <div className="h-6 w-48 rounded bg-gray-200 animate-pulse" />{" "}
//         </div>
//       ) : (
//         <div className="flex items-center justify-center w-full px-4">
//           <span className="md:text-2xl text-xl font-extrabold text-black pt-3">
//             FEATURED CATEGORIES
//           </span>
//         </div>
//       )}
//
//       {/* LEFT BUTTON */}
//       <button
//         ref={leftBtnRef}
//         onClick={() => scroll("left")}
//         className="absolute top-1/2 left-2 -translate-y-1/2 bg-white shadow-md p-2 rounded-full z-10 transition-opacity"
//       >
//         <FaChevronLeft />
//       </button>
//
//       {/* RIGHT BUTTON */}
//       <button
//         ref={rightBtnRef}
//         onClick={() => scroll("right")}
//         className="absolute top-1/2 right-2 -translate-y-1/2 bg-white shadow-md p-2 rounded-full z-10 transition-opacity"
//       >
//         <FaChevronRight />
//       </button>
//
//       {/* Scroll Wrapper */}
//       <div className="relative mx-4 overflow-x-hidden ">
//         <div
//           ref={scrollRef}
//           className="
//             flex
//             overflow-x-auto
//             snap-x snap-mandatory
//             scroll-smooth
//             hide-scrollbar
//             [scrollbar-width:none]
//             [-ms-overflow-style:none]
//             [&::-webkit-scrollbar]:hidden
//             will-change-transform
//           "
//         >
//           {/* LOADING SKELETON (same layout → no flash) */}
//           {loadingCatalogue
//             ? [...Array(6)].map((_, index) => (
//                 <div
//                   key={index}
//                   className="flex-shrink-0 xl:w-[200px] md:w-[140px] w-[100px]"
//                 >
//                   <div className="mt-4 mb-2 flex items-center justify-center bg-gray-200 rounded-full w-[80px] h-[80px] md:w-[110px] md:h-[110px] lg:w-[150px] lg:h-[150px] mx-auto animate-pulse" />
//
//                   <div className="h-4 w-20 mx-auto mt-3 rounded bg-gray-200 animate-pulse" />
//                 </div>
//               ))
//             : catalogues.map((item, index) => (
//                 <div
//                   key={item.id}
//                   className="flex-shrink-0 xl:w-[200px] md:w-[140px] w-[100px] snap-center"
//                 >
//                   <Link to={`/category/${item.catalogue_id}`}>
//                     <div className="mt-4 mb-2 flex items-center justify-center bg-backgroundColor rounded-full w-[80px] h-[80px] md:w-[110px] md:h-[110px] lg:w-[150px] lg:h-[150px] mx-auto">
//                       <img
//                         src={`https://backend.nuhababy.com/${item.image_path}`}
//                         alt={item.title}
//                         loading={index < 4 ? "eager" : "lazy"}
//                         decoding="async"
//                         className="w-full h-full object-cover rounded-full"
//                       />
//                     </div>
//                   </Link>
//
//                   <h3 className="text-center text-xs md:text-sm font-bold">
//                     {item.title}
//                   </h3>
//                 </div>
//               ))}
//         </div>
//       </div>
//     </div>
//   );
// };
//
// export default Catalogue;
import useCatalogueData from "hook/useCatalogueData";
import CategorySlider from "../categorySlider";
const Catalogue = () => {
  const { catalogues, loadingCatalogue } = useCatalogueData();

  return (
      <CategorySlider
          title="FEATURED CATEGORIES"
          data={catalogues}
          loading={loadingCatalogue}
      />
  );
};

export default Catalogue;
